import * as Sentry from '@sentry/react';

import { getClient } from 'utils/utils';
import demoConfig from './demoConfig';
import dollarGeneralConfig from './dollarGeneralConfig';
import dollarGeneralSupportConfig from './dollarGeneralSupportConfig';
import emboldConfig from './emboldConfig';
import emsanaCareConfig from './emsanaCareConfig';
import icubaConfig from './icubaConfig';
import microsoftConfig from './microsoftConfig';
import polkConfig from './polkConfig';
import surgeryPlusConfig from './surgeryPlusConfig';
import walmartConfig from './walmartConfig';
import bnsfConfig from './bnsfConfig';
import jbhuntConfig from './jbhuntConfig';
import soctConfig from './soctConfig';
import clrConfig from './clrConfig';
import customerDemoConfig from './customerDemoConfig';
import soctProviderLookupConfig from './soctProviderLookupConfig';
import quantumConfig from './quantumConfig';
import ensembleConfig from './ensembleConfig';
import ensembleProviderLookupConfig from './ensembleProviderLookupConfig';
import walmartNationalConfig from './walmartNationalConfig';
import convivaConfig from './convivaConfig';
import jpmcConfig from './jpmcConfig';
import referralGuideDemoConfig from './referralGuideDemoConfig';
import bcbsNorthCarolinaConfig from './BCBSNorthCarolinaConfig';
import axaConfig from './axaConfig';
import quantumDemoConfig from './quantumDemoConfig';
import sandboxConfig from './sandboxConfig';

export default function getClientConfig(clientNameParam) {
  return demoConfig;
}
